import { useEffect, useRef } from 'react'

export function useModalFocusManager(open) {
  const triggerRef = useRef(null)

  useEffect(() => {
    if (open) {
      triggerRef.current =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null
    }
  }, [open])

  return triggerRef
}

